/**
 * Brand configuration. Rename the platform here; the web app, emails and
 * webhook headers all read from this file.
 */
export const BRAND = {
    name: 'Traders Portal',
    /** Short name used in tight spots (mobile header, browser tab). */
    shortName: 'Traders Portal',
    /** Used in email subjects and the footer. */
    supportEmail: 'support@example.com',
    docsUrl: '#',
    /** Prefix for outgoing webhook signature header: X-<prefix>-Signature */
    webhookHeaderPrefix: 'SignalwireVault',
};
//# sourceMappingURL=brand.js.map